/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./assetstokens.vue?vue&type=template&id=c14e824a&scoped=true"
import script from "./assetstokens.vue?vue&type=script&lang=js"
export * from "./assetstokens.vue?vue&type=script&lang=js"
import style0 from "./assetstokens.vue?vue&type=style&index=0&id=c14e824a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14e824a",
  null
  
)

export default component.exports